/// <reference path="../../apps/typings/customTds.d.ts" />
import { AppUtils } from '../../shared/utils/index';

 
export namespace Helper {

	export function logError(err: any, application?: string, url?: string, message?: string, withRepsonseText = false): void {
		if (!withRepsonseText && err && err.responseText) {
			err.responseText = '';
		}
		const msg = [application, url, message, JSON.stringify(err)].join('   ----   ');
		try {
			JL().error(msg);
		} catch (e) {
			console.error(`${msg}   ----   Error: ${e.message}`);;
		}
	}

	export function logInfo(title: string, application?: string, url?: string, message?: string): void {
		const d = new Date(),
			datestring = `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}`;

		const msg = [title, datestring, application, url, message].join(' | ');
		try {
			JL().info(msg);
		} catch (e) {
			console.info(`${msg} | Error: ${e.message}`);
		}
	}


	/**
	 * getNestedProperty
	 *
	 * Examines an object and returns nested property by path expression,
	 * f.i. getNestedProperty({nested: { prop: 1 }}, "nested.prop") would return 1.
	 *
	 * @param obj - object to examine
	 * @param path - path exression
	 * @return the last property found in object's path
	 */
	export function getNestedProperty(obj: { [key: string]: any }, path: string): any {
		path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
		path = path.replace(/^\./, '');           // strip a leading dot
		const a = path.split('.');
		// eslint-disable-next-line prefer-const
		for (let k of a) { //NOSONAR
			if (obj != null) {
				if (k in obj) {
					obj = obj[k];
				} else {
					return null;
				}
			}
		}
		return obj;
	}

	export function findByValue(arrOfKeyValues: { [key: string]: any }[], value: string, key?: string): any {
		if (!key) {
			return null;
		}
		const result = arrOfKeyValues.filter((o) => {
			// eslint-disable-next-line eqeqeq
			return o[key] == value; //NOSONAR // no type comparison on "any"
		});
		return result && result.length ? result[0] : null; // or undefined
	}

	/**
	 * linkify.
	 *
	 * converts string with mailto link into html a tag with mailto.
	 */
	export function linkify(inputText: string, subject?: string): string {
		let replacedText: string;

		if (!subject) {
			subject = 'ADAC: Mein Anliegen';
		}

		//URLs starting with http://, https://, or ftp://
		const replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim;
		replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

		//URLs starting with "www." (without // before it, or it'd re-link the ones done above).
		const replacePattern2 = /(^|[^/])(www\.[\S]+(\b|$))/gim;
		replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

		//Change email addresses to mailto:: links.
		const replacePattern3 = /(([a-zA-Z0-9\-_.])+@[a-zA-Z_]+?(\.[a-zA-Z]{2,6})+)/gim;
		replacedText = replacedText.replace(replacePattern3, `<a href="mailto:$1?Subject=${subject}&body=Bitte beschreiben Sie Ihr Anliegen hier">$1</a>`);

		return replacedText;
	}

	/* istanbul ignore next: what is the purpose of this function? */
	export function nullOrDefault(value: any, defaultValue: any): any {
		// eslint-disable-next-line eqeqeq
		if (value == undefined) { //NOSONAR // we don't care if value only "thinks" it's undefined
			return defaultValue;
		}
		return value;
	}

	/* istanbul ignore next: what is the purpose of this function? */
	export function isEmptyString(value: any): boolean {
		// eslint-disable-next-line eqeqeq
		return (undefined == value //NOSONAR // we don't care if value only "thinks" it's undefined
			|| 0 === (`${value}`).length);
	}

	/**
	 * Transforms data-uri to pdf Blob
	 *
	 */
	/* istanbul ignore next: don't know how to test blobs */
	export function getPdfBlobFromDataUri(dataUri: string): Blob {
		const byteCharacters = window.atob(dataUri);
		const byteNumbers = new Array(byteCharacters.length);
		for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
		}
		const byteArray = new Uint8Array(byteNumbers);

		return new Blob([byteArray], { type: 'application/pdf' });
	}

	/**
	 * mapObject - mapps properties from plain map to an object
	 * @param map - key-value map wiht objec properties to set
	 * @param instance - object to map properties onto
	 * @param mapper - function called to convert property values
	 */
	export function mapObject<T>(map: { [key: string]: any }, instance: T, mapper?: (key: string, value: any) => any): T {
		const result: T = instance;
		if (map) {
			Object.keys(map).forEach(function (key: string) {
				result[key as keyof T] = mapper ? mapper(key, map[key]) : map[key];
			});
		}
		return result;
	}

	/**
	 * createFromMap - instantiate an object of a type and maps objects properties from a given map
	 * @see AppUtils.Helper.mapObject
	 * @param map - key-value map wiht objec properties to set
	 * @param type - type (class) of returned object
	 * @param mapper - function called to convert property values
	 */
	export function createFromMap<T>(map: { [key: string]: any }, type: (new () => T), mapper?: (key: string, value: any) => any): T {
		const result = new type();
		AppUtils.Helper.mapObject(map, result, mapper);
		return result;
	}

	export function createFromPartial<T>(partial: Partial<T>, type: (new () => T)): T {
		const result = new type();
		AppUtils.Helper.mapObject(partial, result);
		return result;
	}

	export function scheduleTask(callback: () => void, priority: 'user-blocking' | 'user-visible' | 'background'): void {
		T.Utils.Helper.scheduleTask(callback, priority);
	}
	export function isValidDate(dateString: string): boolean {
		if (!dateString) {
			return false;
		}
		const date = new Date(dateString);
		return moment(date).isValid();
	}

	export function initRteAuthLinks(): void {
		$(document).trigger('PageContext.parseAuthLinks');
	}

	export function isSafari(): boolean {
		const ua = navigator.userAgent;
		const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(ua);
		const isModernSafari = (window as any).safari !== undefined;
		return isSafariBrowser || isModernSafari;
	}

	export function isIOSOrIPadOS(): boolean {
		return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
			(navigator.userAgent.includes("Mac") && "ontouchend" in document);
	}


	export function isMacOS(): boolean {
		return /Mac/.test(navigator.userAgent) && !isIOSOrIPadOS();
	}

	export function isAppleDevice(): boolean {
		return isIOSOrIPadOS() || isMacOS();
	}
}
